import { useCanvasStore } from '@/modules/canvas/store';

/**
 * @description True unless the canvas element with this id is hidden (layer, item or zoom based).
 * Areas share their id with their canvas element. A missing canvas or element counts as visible.
 */
export const isVisibleOnCanvas = (id: string): boolean =>
  useCanvasStore.getState().instance?.getElement(id)?.visible !== false;
